import NavigationBar from "../components/navigationBar";
import CheckoutPageView from "../components/shop/checkout-page/checkoutPageView";
import FooterView from "../components/footerView";


export default function Checkout() {

    const queryParams =  new URLSearchParams(window.location.search);
    const index = queryParams.get('index');
    console.log("This i the index", index)



    return (
        <div>
            {/*<NavigationBar />*/}
            <CheckoutPageView product_id={index} />
            <FooterView />
        </div>
    )
}